module.exports = __webpack_public_path__ + "img/xxzx.05937f43.jpg";